class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    if (this.hasAttribute('data-hover-open')) {
      this.hoverQuery = window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)');
      this.addEventListener('pointerenter', (event) => {
        if (!this.hoverQuery.matches || event.pointerType !== 'mouse') return;
        window.clearTimeout(this.hoverCloseTimer);
        this.mainDetailsToggle.open = true;
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
      });
      this.addEventListener('pointerleave', () => {
        if (!this.hoverQuery.matches) return;
        this.hoverCloseTimer = window.setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        }, 250);
      });
      this.addEventListener('focusin', () => window.clearTimeout(this.hoverCloseTimer));
    }
  }

  close() {
    window.clearTimeout(this.hoverCloseTimer);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
